/* esm.sh - applesauce-core@5.2.0/dist/helpers/regexp */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/regexp.mjs";
